import { http } from '@/utils/request'
import store from '@/store'
import mTypes from '@/store/mutationsTypes'
// 验证码

export const sendSms = async (data) => {
  return await http.post({
    url: '/sms/sendmsg',
    data
  })
}

export const checkSms = async (data) => {
  return await http.post({
    url: '/sms/check',
    data
  })
}

export const fetchHomeCarousel = async (data) => {
  return await http.post({
    url: '/commononline/carousel',
    data
  })
}

export const fetchGrade = async (data) => {
  return await http.post({
    url: '/user/getgrade',
    data
  })
}

export const checkShopCode = async (data) => {
  return await http.post({
    url: '/user/checkorgbycode',
    data
  })
}

export const fastLogin = async (data) => {
  let res = await http.post({
    url: '/useronline/fastlogin',
    data
  })
  if (res.code === 1) {
    store.commit(mTypes.userInfo, res.data)
  }
  return res
}

export const userLogin = async (data) => {
  let res = await http.post({
    url: '/useronline/login',
    data
  })
  if (res.code === 1) {
    store.commit(mTypes.userInfo, res.data)
  }
  return res
}

export const assignLogin = async (data) => {
  let res = await http.post({
    url: '/useronline/assistlogin',
    data
  })
  if (res.code === 1) {
    store.commit(mTypes.userInfo, res.data)
  }
  return res
}
/**
 * @mobile
 * @password
 * @repassword
 * @code
 *
 * @param {*} data
 */
export const register = async (data) => {
  return await http.post({
    url: '/useronline/register',
    data
  })
}

export const resetPasswd = async (data) => {
  return await http.post({
    url: '/user/password',
    data
  })
}

export const teacherResetPasswd = async (data) => {
  return await http.post({
    url: '/useronline/password',
    data
  })
}

/**
 * @name
 * @sex
 * @grade
 * @school
 * @org_id
 * @param {*} data
 */
export const setPersonal = async (data) => {
  return await http.post({
    url: '/useronline/personal',
    data
  })
}

export const changePhone = async (data) => {
  return await http.post({
    url: '/usercenter/changemobile',
    data
  })
}

/**
 * type int  required 0 学生 1 老师
 * show_type int required 0 时间轴 1 日历
 * @param {*} data
 */
export const fetchTimetable = async (data) => {
  return await http.post({
    url: '/useronline/timetable',
    data
  })
}

/**
 *
 * @param {*} data
 */

export const fetchCalendar = async (data) => {
  return await http.post({
    url: '/useronline/tablecalendar',
    data
  })
}

// 用户协议

export const fetchRegister = async (data) => {
  return await http.post({
    url: '/useronline/registration',
    data
  })
}

export const fetchPrivacy = async (data) => {
  return await http.post({
    url: '/useronline/privacyprotection',
    data
  })
}

export const postForm = async (url, data) => {
  return await http.post({
    url: url,
    data
  })
}

export const getForm = async (url, params) => {
  return await http.get({
    url: url,
    params
  })
}

// 课程详情
export const courseDetail = async (data) => {
  return await http.post({
    url: '/usercenter/courseinfo',
    data
  })
}

// 下单
export const coursePay = async (data) => {
  return await http.post({
    url: indexUrl + '/index/orderonline/placeorder',
    data
  })
}

// 上传头像
export const uploadFace = async (data) => {
  return await http.post({
    url: '/common/uploadonline',
    data
  })
}

// 课程评价
export const getappRaise = async (data) => {
  return await http.post({
    url: '/usercenter/getappraise',
    data
  })
}

// get exam words
export const getExamWords = async (data) => {
  return await http.post({
    url: '/exam/getwords',
    data
  })
}

export const getListenWords = async (data) => {
  return await http.post({
    url: '/exam/getlistenwords',
    data
  })
}

export const submitTestResult = async (data) => {
  return await http.post({
    url: '/exam/upresult',
    data
  })
}

export const getBrandSkinConfig = async (data) => {
  return await http.post({
    url: '/brand/getSkinConfig',
    data
  })
}

export const getMsgList = async (data) => {
  return await http.post({
    url: '/msg/list',
    data
  })
}

export const getFamousReadList = async (data) => {
  return await http.post({
    url: '/recreation/read_v2',
    data
  })
}
export const getFamousLevels = async (data) => {
  return await http.post({
    url: '/recreation/levels',
    data
  })
}
export const getFamousChapter = async (data) => {
  return await http.post({
    url: '/recreation/chapter_v2',
    data
  })
}

export const searchWord = async (data) => {
  return await http.post({
    url: '/read/searchword',
    data
  })
}

export const getMsgDetail = async (data) => {
  return await http.post({
    url: '/msg/view',
    data
  })
}
export const getTopMsg = async (data) => {
  return await http.post({
    url: '/msg/top_msg',
    data
  })
}
export const getOnlineStatus = async (data) => {
  return await http.post({
    url: '/online/status',
    data
  })
}

export const getAssessListRecord = async (data) => {
  return await http.post({
    url: '/test_online/list',
    data
  })
}

export const getAssessDetail = async (data) => {
  return await http.post({
    url: 'test_online/detail',
    data
  })
}
export const test_online_report = async (data) => {
  return await http.post({
    url: 'test_online/report',
    data
  })
}
export const test_online_ranking = async (data) => {
  return await http.post({
    url: 'test_online/ranking',
    data
  })
}
export const test_online_submit = async (data) => {
  return await http.post({
    url: 'test_online/submit',
    data
  })
}